<main class="agpr-vi-results">
    <section
        class="agpr-vi-results-main"
        [attr.aria-label]="'Common.layout.main' | localize"
    >
        <header class="agpr-vi-results-header">
            <div class="agpr-vi-results-header-center">
                <h2 class="agpr-vi-results-header-center-label">
                    <span>{{ monitor?.name }}</span>
                </h2>
                <span class="agpr-vi-results-header-center-divider"></span>
                <agpr-tabs-toggle
                    [id]="id + '_tabsToggle'"
                    [options]="viewModeOptions"
                    [ngModel]="selectedViewMode"
                    (ngModelChange)="viewModeChanged($event)"
                ></agpr-tabs-toggle>
            </div>
        </header>

        <div class="agpr-vi-results-content">
            <router-outlet></router-outlet>
        </div>

    </section>

    <agpr-action-bar [headingContext]="'Monitor.MAD.footer.headingContext' | localize">
        @let isActive = monitor?.status === monitorStatus.active;
        @let isPaused = monitor?.status === monitorStatus.paused;
        <ng-template #left>
            <div class="agpr-vi-results-actions">
                <agpr-button
                    [id]="id + '_editButton'"
                    label="edit"
                    [agprTooltip]="isActive ? 'VisibilityIntelligence.reports.edit.tooltip' : ''"
                    (click)="edit()"
                    [disabled]="isActive"
                ></agpr-button>
            </div>
        </ng-template>
        <ng-template #right>
            @if (isActive) {
                <agpr-button
                    [id]="id + '_pauseButton'"
                    label="pause"
                    [style]="buttonType.primaryB"
                    (click)="pause()"
                ></agpr-button>
            }
            @if (isPaused) {
                <agpr-button
                    [id]="id + '_activateButton'"
                    label="activate"
                    [style]="buttonType.primaryB"
                    (click)="activate()"
                ></agpr-button>
            }
        </ng-template>
    </agpr-action-bar>
</main>

<ng-template #activateConfirmContent>
    <div class="agpr-vi-results-activateConfirm">
        <p [innerHTML]="'VisibilityIntelligence.monitor.activateConfirm.message' | localize: {
            name: monitor?.name ?? '',
            used: monitor?.questions?.length ?? 0,
            remaining: remainingActiveQuestionQuota
        }"></p>
        <agpr-message [severity]="messageSeverities.info" [bottomMargin]="false">
            <div [innerHTML]="'VisibilityIntelligence.monitor.activateConfirm.banner' | localize: {contactLink: 'https://www.agilitypr.com/contact/'}"></div>
        </agpr-message>
    </div>
</ng-template>

<ng-template #insufficientQuotaContent>
    <div class="agpr-vi-results-insufficientQuota">
        <agpr-message [severity]="messageSeverities.error" [bottomMargin]="false">
            {{ 'VisibilityIntelligence.monitor.activate.insufficientQuota.heading' | localize: { name: monitor?.name ?? '' } }}
        </agpr-message>
        <p [innerHTML]="'VisibilityIntelligence.monitor.activate.insufficientQuota.message' | localize: {
            required: monitor?.questions?.length ?? 0,
            remaining: remainingActiveQuestionQuota
        }"></p>
        <p [innerHTML]="'VisibilityIntelligence.monitor.activate.insufficientQuota.hint' | localize: {contactLink: 'https://www.agilitypr.com/contact/'}"></p>
    </div>
</ng-template>
